/**
 * Module dependencies.
 */

import { useDebounce } from 'app/hooks/use-debounce';
import React, { ReactNode } from 'react';
import { SpinnerOverlay } from 'app/components/ui/spinner';

/**
 * `Props` type.
 */

type Props = {
  isLoading?: boolean;
  debounceToLoading?: number;
  debounceToRender?: number;
  children: ReactNode;
};

/**
 * Export `Loading` component.
 */

export function Loading(props: Props): JSX.Element {
  const { children, isLoading, debounceToLoading = 0, debounceToRender = 150 } = props;

  const debouncedLoading = useDebounce(isLoading, isLoading ? debounceToLoading : debounceToRender);

  if (debouncedLoading) {
    return <SpinnerOverlay />;
  }

  return <>{children}</>;
}
